import {
  PhoneOutlined,
  MailOutlined,
  UserOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import { Avatar, Popover, Card, Row, Button } from 'antd'
import Meta from 'antd/lib/card/Meta'
import { capitalize, find } from 'lodash'
import React from 'react'
import {
  ACTING_ROLE_ADMIN,
  ActingUserRole,
  COLLABORATOR_ROLE_EDITOR,
  COLLABORATOR_ROLE_OWNER,
} from '@/screens/Order/Pages/Order.constant'
import { getAvatarText } from './TimeActionHeroPanel.helper'

type Props = {
  data: any
  actingUserRole?: ActingUserRole
  onAddClick?: () => void
}

function AvatarGroup({ data, actingUserRole, onAddClick }: Props) {
  function checkURL(url) {
    return url ?? ''
  }
  const canManage =
    actingUserRole === COLLABORATOR_ROLE_OWNER ||
    actingUserRole === COLLABORATOR_ROLE_EDITOR ||
    actingUserRole === ACTING_ROLE_ADMIN

  return (
    <Row align="middle" style={{ gap: 8 }}>
      <Avatar.Group
        maxCount={4}
        size={40}
        className="avatar-group-popver-name"
        maxStyle={{
          color: '#f56a00',
          backgroundColor: '#fde3cf',
        }}
      >
        {!!data?.length &&
          data.map((avatar, i) => {
            return (
              <Popover
                key={i}
                placement="bottom"
                content={
                  <Card className="p-2" bordered={false}>
                    <Meta
                      avatar={
                        <Avatar
                          src={checkURL(avatar?.user?.avatar?.url_path)}
                          alt={avatar?.user?.first_name}
                        >
                          {getAvatarText(
                            `${avatar?.user?.first_name || ''} ${
                              avatar?.user?.last_name || ''
                            }`.trim() ||
                              avatar?.user?.email ||
                              ''
                          )}
                        </Avatar>
                      }
                      title={`${avatar?.user?.first_name} ${avatar?.user?.last_name}`}
                    />
                    <p className="collab-popover-role">{`${capitalize(
                      avatar?.roles?.role
                    )}`}</p>

                    <Row
                      wrap={false}
                      align={'middle'}
                      className="collab-popover-contact-container"
                    >
                      <MailOutlined /> &nbsp;
                      <a href={`mailto:${avatar?.user?.email ?? ''}`}>
                        {avatar?.user?.email ?? ''}
                      </a>
                    </Row>
                  </Card>
                }
              >
                <Avatar
                  src={`${checkURL(avatar?.user?.avatar?.url_path)}`}
                  alt={avatar?.user?.first_name}
                  icon={<UserOutlined />}
                >
                  {getAvatarText(
                    `${avatar?.user?.first_name || ''} ${
                      avatar?.user?.last_name || ''
                    }`.trim() ||
                      avatar?.user?.email ||
                      ''
                  )}
                </Avatar>
              </Popover>
            )
          })}
      </Avatar.Group>
      {canManage && onAddClick && (
        <Button
          shape="circle"
          icon={<PlusOutlined style={{ fontSize: '16px' }} />}
          onClick={onAddClick}
          style={{
            width: 40,
            height: 40,
            minWidth: 40,
            borderRadius: '50%',
            backgroundColor: '#EF9747',
            border: '2px solid #fff',
            marginLeft: -18,
            zIndex: 1,
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      )}
    </Row>
  )
}
export default AvatarGroup
